module.exports = __webpack_public_path__ + "img/chart-bar-hori-multi.fd58380a.svg";